import $ from 'jquery';

const siteSearch = {
    init() {
        const list = $('.search-results');
        const totalListItems = list.find('> li').length;
        const hashKey = 'list-result-items';
        const showMoreBtn = $('.search-results-more');

        if (window.location.hash.includes(hashKey)) {
            showMore(window.location.hash.split('=')[1], '> li');
        }

        showMoreBtn.on('click', function () {
            showMoreBtn.addClass('is-loading');

            setTimeout(() => {
                showMoreBtn.removeClass('is-loading');
                showMore(showMoreBtn.data('pagination'), '> li.d-none');
            }, 300);

            return false;
        });

        function showMore(pagination, select) {
            list.find(select).slice(0, pagination).removeClass('d-none');

            var visibleListItems = list.find('> li:not(.d-none)').length;

            window.location.hash = `${hashKey}=${visibleListItems}`;

            if (totalListItems === visibleListItems) {
                showMoreBtn.hide();
            }
        }
    }
};

export default siteSearch;
